<template>
    <div class="knowledge-wrap" v-if="knowledgeData.length > 0">
        <div class="know-tit">
            <span>相关知识{{ knowledgeData.length }}</span>
            <i>展开</i>
        </div>
        <div class="know-lists">
            <div class="know-item" v-for="(item,i) in knowledgeData" :key="i">
                <h5>Q: 问题</h5>
                <p>A: 描述</p>
                <span><i>admin</i>2019-02-02</span>
            </div>
        </div>
    </div>
</template>

<script>
    import services from "../services/common.service"
    export default {
        props:{
            keyword:String,   // 匹配的关键字
            type:String,      //  类型
        },
        data() {
            return {
                knowledgeData:[]
            }
        },
        watch:{
            keyword:{
                handler(val){
                    if(val== ''){
                        this.knowledgeData = []
                    }else{
                        this.getList();
                    }
                }
            }
        },
        created() {

        },
        methods: {
            getList(){
                let params = {
                    keyword:this.keyword,
                    type:this.type
                };
                if(this.keyword == ''){
                    console.log("====")
                    this.knowledgeData = [12,77]
                };
                services.getList(params).then(res => {
                    this.knowledgeData = res;
                }).catch(err => {

                })
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.knowledge-wrap{
    width:100%;
    overflow-y: auto;
    padding:0 10px;
    border:1px solid #cccccc;
    box-sizing: border-box;
    .know-tit{
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #cccccc;
    }
    .know-lists{
        padding:6px 0;
        .know-item{
            margin-bottom: 20px;
            border-bottom: 1px solid #cccccc;
            &:last-child{
                border-bottom:none;
            }
        }
        h5,span{
            color: blue;
        }
    }
}
</style>